<template>
  <div>
    <KCinitialize />
  </div>
</template>

<script>
// 获取接口地址
import KCinitialize from '@/components/Kccsh/KCinitialize'

export default {
  name: 'Kccsh',
  components: {
    // sideMenu,
    // Header,
    KCinitialize
  },
  data() {
    return {}
  },
  created: function() {},
  methods: {}
}
</script>

<style scoped>
</style>
